import { createAsyncThunk } from '@reduxjs/toolkit';
import { activateConcierge, deactivateConcierge } from 'services/api/concierge.api.service';
import { ThunkAPI } from 'typings';
import { setNotification, setLoading } from 'state/app.state';
import { apiErrorNotification } from 'utils/functions';

export const apiChangeAvailability = createAsyncThunk(
  'concierge/apiChangeAvailability',
  async ({ isActive, reason }: { isActive: boolean; reason?: string }, thunkApi: ThunkAPI) => {
    try {
      thunkApi.dispatch(setLoading(true));
      isActive ? await activateConcierge() : await deactivateConcierge(reason);

      return { isActive };
    } catch (error) {
      thunkApi.dispatch(setNotification(apiErrorNotification(error)));
      return thunkApi.rejectWithValue({ error: 'Fail' });
    } finally {
      thunkApi.dispatch(setLoading(false));
    }
  }
);
